import { Action, State } from './types'

const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case 'ADD_POPUP':
      return [...state, action.payload]
    case 'REMOVE_POPUP':
      return state.filter((data) => data.id !== action.payload)
    default:
      return state
  }
}

export default reducer
